import React from 'react';
import Column from 'src/frontend-common/components/Column';
import { SkeletonWrapper } from './style';
import { Skeleton } from '@mui/material';
import Row from 'src/frontend-common/components/Row';

const RiskChartSkeleton: React.FC = () => (
  <SkeletonWrapper data-testid="risk-chart-skeleton">
    <Column>
      <Skeleton variant="circular" width={250} height={250} />
    </Column>
    <Row style={{ marginTop: 26, marginBottom: 24 }}>
      {[...Array(4)].map((_, i) => (
        <Row style={{ alignItems: 'center', marginRight: 15 }} key={`riskchart-skele-${i}`}>
          <Skeleton variant="circular" width={10} height={10} style={{ marginRight: 10 }} />
          <Skeleton variant="text" width={Math.floor(Math.random() * 45) + 30} height={25} />
        </Row>
      ))}
    </Row>
  </SkeletonWrapper>
);

export default RiskChartSkeleton;
